import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

// Rental Components
import { RentalOrderComponent } from './rental-order/rental-order.component';
import { DetailsRentalOrderComponent } from './rental-order/details-rental-order/details-rental-order.component';
import { RentalEquipmentsComponent } from './rental-equipments/rental-equipments.component';
import { RentalIncomeDispatchComponent } from './rental-income-dispatch/rental-income-dispatch.component';
import { ModalRentalOrderComponent } from './rental-order/modal-rental-order/modal-rental-order.component';
import { RentalOrderSummaryComponent } from './rental-order/rental-order-summary/rental-order-summary.component';

const RentalComponents = [
  RentalOrderComponent,
  DetailsRentalOrderComponent,
  RentalEquipmentsComponent,
  RentalIncomeDispatchComponent,
  ModalRentalOrderComponent,
  RentalOrderSummaryComponent
];

@NgModule({
  declarations: RentalComponents,
  imports: [SharedModule],
  exports: RentalComponents
})
export class RentalModule { }
